import algoliasearch from "algoliasearch";

const client = algoliasearch("GAHFGLK8XW", "71228e68be199e068f3020147a00d429");
const index = client.initIndex("apideneme");

export { index };
